import { Component, OnInit, EventEmitter, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TechnicianService } from '../../../shared/service/technician.service';
import { ProvidedServiceService } from '../../../shared/service/provided-service.service';
import { Technician } from '../../../shared/model/technician';
import { AutoEletric } from '../../../shared/model/auto-eletric';
import { AutoEletricService } from '../../../shared/service/auto-eletric.service';
import { AutoEletricProvidedService } from '../../../shared/model/auto-eletric-provided-service';
import { AutoEletricProvidedServiceService } from '../../../shared/service/auto-eletric-provided-service.service';
import { CpfPipe } from '../../../shared/pipe/cpf.pipe';
import { PhonePipe } from '../../../shared/pipe/phone.pipe';
import { SaveHttpError } from '../../../shared/error/save-http-error';
import { UpdateHttpError } from '../../../shared/error/update-http-error';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { Vehicle } from '../../../shared/model/vehicle';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-technician-create-update',
  templateUrl: './technician-create-update.component.html',
  styleUrls: ['./technician-create-update.component.css']
})
export class TechnicianCreateUpdateComponent implements OnInit, AfterViewChecked {
  partialTitle: string;
  newTechnician: Technician;
  autoEletrics: Array<AutoEletric>;
  autoEletricProvidedServices: Array<AutoEletricProvidedService>;
  autoEletricAttributesTree = ['name'];
  providedServicesAttributesTree = ['providedService', 'name'];
  providedServicesComparableAttribute = ['providedService', 'id'];
  editMode = false;
  private technicianId: number;
  private cpfPipe: CpfPipe;
  private phonePipe: PhonePipe;

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private _technicianService: TechnicianService,
              private _autoEletricService: AutoEletricService,
              private _autoEletricServiceService: AutoEletricProvidedServiceService,
              private _toastService: ToastService) {
    this.setUpObjects();
    this.editModeVerify();
    this.setPipes();
    this.setUpObservers();
  }

  ngOnInit() { }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  save() {
    if (this.editMode) {
      this._technicianService.update(this.newTechnician);
    } else {
      this._technicianService.save(this.newTechnician);
    }
  }

  editModeVerify() {
    this.partialTitle = 'Cadastrar ';
    this._route.params.subscribe(params => {
      if (params['id']) {
        this.editMode = true;
        this.technicianId = +params['id'];
        this._technicianService.findById(this.technicianId);
        this.partialTitle = 'Editar ';
      }
    });
  }

  updateSelectedProvidedServices(services) {
    this.newTechnician.autoEletricServices = services;
  }

  checkProvidedService(item) {
    let isChecked = false;
    if (this.newTechnician.autoEletricServices) {
      this.newTechnician.autoEletricServices.forEach(service => {
        if (service.id === item.id) {
          isChecked = true;
        }
      });
    }
    return isChecked;
  }

  addOrRemoveFromTechnicianServices(service) {
    let wasSelected = false;
    if (this.newTechnician.autoEletricServices) {
      this.newTechnician.autoEletricServices.forEach((selectedOption, index, array) => {
        if (selectedOption.id === service.id) {
          array.splice(index, 1);
          wasSelected = true;
        }
      });
    }
    if (!wasSelected) {
      this.newTechnician.autoEletricServices.push(service);
    }
  }

  findAutoEletricsByName(name) {
    this._autoEletricService.findByName(name);
  }

  findAutoEletricService(autoEletric) {
    this.newTechnician.autoEletric = autoEletric;
    this._autoEletricServiceService.findListByAutoEletricId(autoEletric.id);
  }

  setPipes() {
    this.cpfPipe = new CpfPipe();
    this.phonePipe = new PhonePipe();
  }

  applyCpfMask(event) {
    return this.cpfPipe.transform(event.target.value, event.key);
  }

  applyPhoneMask(event) {
    return this.phonePipe.transform(event.target.value, event.key);
  }

  goBack() {
    this._router.navigate(['technicians/list']);
  }

  private setUpObjects() {
    this.newTechnician = new Technician();
    this.newTechnician.vehicle = new Vehicle();
    this.newTechnician.autoEletricServices = new Array();
    this.newTechnician.argosUser = {};
    this.autoEletrics = new Array();
  }

  private setUpObservers() {
    if (this.editMode) {
      this.setUpSaveUpdateAction(this._technicianService.update$);
    } else {
      this.setUpSaveUpdateAction(this._technicianService.save$);
    }
    this.setUpFindAction(this._technicianService.find$);
    this.setUpErrorAction(this._technicianService.error$);
    this.setUpFindAutoEletrics(this._autoEletricService.find$);
    this.setUpFindAutoEletricServices(this._autoEletricServiceService.find$);
  }

  private setUpSaveUpdateAction(observable) {
    observable
      .subscribe(() => {
        this.goBack();
      });
  }

  private setUpFindAction(observable) {
    observable
      .filter(technician => technician instanceof Technician)
      .subscribe(technician => {
        this.newTechnician = technician;
        this.newTechnician.argosUser = technician.argosUser || {};
        this.autoEletrics = new Array();
        this.newTechnician.vehicle = technician.vehicle || {};
        this.autoEletrics.push(this.newTechnician.autoEletric);
        this.findAutoEletricService(this.newTechnician.autoEletric);
      });
  }

  private setUpErrorAction(observable) {
    observable
      .filter(error => error instanceof SaveHttpError || error instanceof UpdateHttpError)
      .subscribe(error => {
        this.newTechnician.vehicle = this.newTechnician.vehicle || new Vehicle();
        this._toastService.showMessage(error.text, 4000);
      });
  }

  private setUpFindAutoEletrics(observable) {
    observable
      .filter(autoEletrics => autoEletrics instanceof Array)
      .subscribe(autoEletrics => this.autoEletrics = autoEletrics);
  }

  private setUpFindAutoEletricServices(observable) {
    observable
      .filter(autoEletricProvidedServices => autoEletricProvidedServices instanceof Array)
      .subscribe(autoEletricProvidedServices => {
        this.autoEletricProvidedServices = autoEletricProvidedServices;
      });
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/technician/component/technician-create-update/technician-create-update.component.ts